import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { migraTipoDePasoIns } from "services/services-mia/migra";

export default function InsertModal({ updateList, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async ({ migraTipoDePasoCod, migraTipoDePasoNombre }) => {
        setInRequest(true);

        const response = await migraTipoDePasoIns(
            {
                migraTipoDePasoCod,
                migraTipoDePasoNombre,
            },
            credentials
        );

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Tipo de paso añadido exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                migraTipoDePasoCod: "",
                migraTipoDePasoNombre: "",
            }}
            validationSchema={yup.object({
                migraTipoDePasoCod: yup
                    .string(FORM_ERROR_MESSAGES.text)
                    .max(45, "Máximo 45 caracteres")
                    .required(FORM_ERROR_MESSAGES.required),
                migraTipoDePasoNombre: yup
                    .string(FORM_ERROR_MESSAGES.text)
                    .required(FORM_ERROR_MESSAGES.required)
                    .max(150, "Máximo 150 caracteres"),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="migraTipoDePasoCod"
                        labelText="Código"
                        placeholder="Ingrese código"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="migraTipoDePasoNombre"
                        labelText="Nombre"
                        placeholder="Ingrese nombre"
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Agregar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
